import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { components } from 'react-select';
export const DropdownIndicator = props => _jsx(components.DropdownIndicator, {
  ...props,
  children: props.selectProps.dropdownIndicatorIcon
});